import { useTranslation } from 'react-i18next';
import SimpleMenuItem from '../../components/SimpleMenuItem';
import { Icon, label, route } from './config';

export default function DokumenteMenuItem() {
  const { t } = useTranslation();
  return <SimpleMenuItem route={route} label={t(label)} icon={Icon} />;
}
